import { lazy } from 'react';
import { authRoles } from 'app/auth';

const DataAppConfig = {
	settings: {
		layout: {}
	},
	auth: [...authRoles.warehouseMan, ...authRoles.warehouseAssistant],
	routes: [
		{
			exact: true,
			path: '/apps/warehouse-returned-products',
			component: lazy(() => import('./list/Datas'))
		},
		{
			exact: true,
			path: '/apps/warehouse-returned-products/:groupId',
			component: lazy(() => import('./details/Datas'))
		}
	]
};

export default DataAppConfig;
